// extracted by mini-css-extract-plugin
export default {"Editor":"Editor--o3020"};